import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Point } from 'geojson';
import { from, ReplaySubject, Subject } from 'rxjs';
import { find, switchMap, takeUntil } from 'rxjs/operators';
import { ApiGatewayService } from '~app/shared/api-gateway.service';
import { MapElement } from '~app/shared/map/map-element.model';
import { MapService } from '~app/shared/map/map.service';
import { TAnalyzePointsResult } from './v2l.type';

//// Properties needs further TLC..
const staticProps = {
  prop1: 1,
  prop2: 2,
};

@Injectable()
export class V2LService extends ApiGatewayService implements OnDestroy {
  private readonly v2lLayerVisible$ = new Subject<boolean>();
  private readonly ngUnsubscribe$ = new Subject<void>();
  private readonly analyzes$ = new ReplaySubject<TAnalyzePointsResult>(1);
  private analyzesInitialized = false;

  constructor(
    protected http: HttpClient,
  ) {
    super(http, 'v2l-api');
    console.log('V2LService default constructor');
  }

  ngOnDestroy(): void {
    this.v2lLayerVisible$.complete();
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  /**
   * Query and draw V2L distinct coordinate points to canvas
   * @param ms MapService reference
   */
  public initMapItems(ms: MapService) {
    console.log('V2LService initMapItems');

    //// construct listener of v2l layer's toggle's
    //// single v2l layer per tenant
    ms.layersR$.pipe(
      find(layer => layer.metadata.v2lLayer),
      switchMap(layer => layer.isVisible$),
      takeUntil(this.ngUnsubscribe$)
    ).subscribe((isVisible: boolean) => {
      this.v2lLayerVisible$.next(isVisible);
    });

    //// if layer is activated, fetch data if not yet fetched
    this.v2lLayerVisible$.pipe(
      takeUntil(this.ngUnsubscribe$)
    ).subscribe( (v2lLayerVisibility) => {
      console.log(`v2l visibility: ${v2lLayerVisibility}`);
      if (!this.analyzesInitialized && v2lLayerVisibility) {
        from(this.getDistinctCoordinates()).subscribe({
          next: (points: TAnalyzePointsResult) => {
            this.analyzes$.next(points);
          }
        });
        this.analyzesInitialized = true;
      }
    });

    //// draw the items
    this.analyzes$.pipe(
      takeUntil(this.ngUnsubscribe$)
    ).subscribe( (points) => {
      //// at moment, we have single v2l layer for tenant, if configuration error (multiple v2l layers defined) picking the first one
      const v2lLayer = ms.getLayerList().find((layer) => layer.metadata.v2lLayer);
      const elements = points.data.map(point => {
        return new MapElement<Point>(Math.random(), v2lLayer, staticProps, 'Feature', point);
      });
      if (v2lLayer) {
        console.log(`drawing items on ${v2lLayer.id}`);
        v2lLayer.pushFeatures(elements);
      }
    });
  }

  /**
   * fetch distinct coordinate pairs (Point) from V2L
   * NOTE: let this be, as long as the other endpoints get stabilized.
   * @returns array of distinct Points
   */
  public getDistinctCoordinates(): Promise<TAnalyzePointsResult> {
    return this.get(['v2l-egress', 'distinct', 'NaytteenottoMatka.Naytteenotto.NaytteenottoPaikka.geometry']);
  }
}
